module.exports = __webpack_public_path__ + "img/proyecto_14.45021833.png";